import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { DocumentosContext } from '../../../context/documentos/DocumentosContext';
import { Paginator } from '../../../components/paginator/Paginator';
import { headers } from "./configGrid/headers";
import { formatRows } from "./configGrid/rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../components/Title";
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import SearchButton from "../../../components/SearchButton/SearchButton";
import ConfirmDialog from "../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';

export const Datatable = ({ onSelect, onClose,enableCreate=true}) => {
  const titleGrid = "Tipos De Documentos"
  useDocumentTitle(titleGrid);
  const contexto = useContext(DocumentosContext);
  const { deleteDocumentoData, getDocumentosListaData } = contexto;
  const navigate = useNavigate();

  const nameData = "documentos";
  const descData = "td_descripcion";
  const getData = getDocumentosListaData;
  const deleteData = deleteDocumentoData;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Ref para busqueda
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity } = await fetchEntityData(
        getData,
      );
      setListaItems(dataEntity);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem);
      fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };
  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  const getDynamicValue = (row, key) => {
    return row[key];
  };

  const handleRowClick = (params) => {
    const selectedId = params.row.id; // Capturar el id del Cliente 
    const selectedDesc = getDynamicValue(params.row, descData);
    onSelect && onSelect(selectedId, selectedDesc); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice().concat(headers.filter((column) => !column.hidden));
    return onSelect ? commonCols : commonCols.concat(getActionColumn(handleClickEdit, openModal));
  }, [onSelect]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);


  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h3>{titleGrid}</h3>
        <div className="filterContainer">
          <div className="searchContainer">
            
          </div>
          {enableCreate &&
          <div className="linkContainer">
            <Link to={`/${nameData}/new`} className="link">Agregar</Link>
          </div>
          }
        </div>
      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              onRowClick={handleRowClick}
              isLoading={isLoading}
            />
          </div>
          <div className="paginatorWrapper">
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />

          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>

      )}
    </div>
  );
};

export default Datatable;
